import { Injectable, Inject } from '@angular/core';
import 'rxjs/add/observable/of';
import { CookieService } from 'ngx-cookie-service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { plainToClass } from 'class-transformer';
import { Staff, Ticket } from 'orv-ui-base-lib';
import { Guid } from 'guid-typescript';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable()
export class SurveyService {

  opqid: string;

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, protected http: HttpClient,
    private cookieService: CookieService) {

  }

  getTicket(opid) {
    return this.http.get('/ws/jwt/token', {}).mergeMap((token: any) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': 'Bearer: ' + token.jwt
        }),
      };
      return this.http.get(`/ws/hvpublic/customersurvey/${opid}`, httpOptions)
        .map(res => {
          const s: Ticket = plainToClass(Ticket, res as Object);
          return s;
        });
    });
    // return Observable.of(new User('test', 'test')); mock login
  }

  submitFeedback(body: any) {
    return this.http.get('/ws/jwt/token', {}).mergeMap((token: any) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': 'Bearer: ' + token.jwt
        }),
      };
      return this.http.post('/ws/hvpublic/customersurvey/' + this.opqid, body, httpOptions)
        .map(res => {
          return res;
        });
    });

  }


}

